<template>
    <div class="page_home_server flex-col">
        <div class="text-group_365 flex-col justify-between">
            <span class="text_63">服务优势</span>
            <span class="text_64">SERVICE&nbsp;ADVANTAGES</span>
        </div>
        <div class="group_179 flex-col">
            <div class="block_server flex-row justify-between" ref="serviceAdvantages">
                <div class="box_content flex-col">
                    <div class="section_83 flex-row justify-between">

                        <div class="service-item flex-col align-center">
                            <img class="label_icon" referrerpolicy="no-referrer" src="../../../assets/index/chpc_home_count03.png"/>
                            <div class="data_count">
                                <span class="data_count_pre">近</span>
                                <span class="item-value">{{serverCount[0]}}</span>
                                <span class="data_count_unit">年</span>
                            </div>
                            <span class="item-desc">药械/大健康行<br />业服务经验</span>
                            <div class="item-divider"></div>
                        </div>

                        <div class="service-item flex-col align-center">
                            <img class="label_icon" referrerpolicy="no-referrer" src="../../../assets/index/chpc_home_count06.png"/>
                            <div class="data_count">
                                <span class="item-value">{{serverCount[1]}}+</span>
                                <span class="data_count_unit">家</span>
                            </div>
                            <span class="item-desc">大型药械外企<br />优选供应商</span>
                            <div class="item-divider"></div>
                        </div>

                        <div class="service-item flex-col align-center">
                            <img class="label_icon" referrerpolicy="no-referrer" src="../../../assets/index/chpc_home_count05.png"/>
                            <div class="data_count">
                                <span class="item-value">{{serverCount[2]}}+</span>
                                <span class="data_count_unit">家</span>
                            </div>

                            <span class="item-desc">药械/大健康<br />合作客户</span>
                            <div class="item-divider"></div>
                        </div>

                        <div class="service-item flex-col align-center">
                            <img class="label_icon" referrerpolicy="no-referrer" src="../../../assets/index/chpc_home_count04.png"/>
                            <div class="data_count">
                                <span class="item-value">{{serverCount[3]}}+</span>
                                <span class="data_count_unit">家</span>
                            </div>
                            <span class="item-desc">年均可疑<br />商户走访量</span>
                        </div>

                    </div>
                    <div class="section_84  flex-row justify-between">

                        <div class="service-item flex-col align-center">
                            <img class="label_icon" referrerpolicy="no-referrer" src="../../../assets/index/chpc_index.map_03.png"/>
                            <div class="data_count">
                                <span class="item-value">{{serverCount[7]}}+</span>
                                <span class="data_count_unit">份</span>
                            </div>

                            <span class="item-desc">近3年<br />执行覆盖城市</span>
                            <div class="item-divider"></div>
                        </div>
                        <div class="service-item flex-col align-center">
                            <img class="label_icon" referrerpolicy="no-referrer" src="../../../assets/index/chpc_home_count02.png"/>
                            <div class="data_count">
                                <span class="item-value">{{serverCount[4]}}+</span>
                                <span class="data_count_unit">次</span>
                            </div>
                            <span class="item-desc">年均HCO/CSO/<br />DLR DD报告</span>
                            <div class="item-divider"></div>
                        </div>

                        <div class="service-item flex-col align-center">
                            <img class="label_icon" referrerpolicy="no-referrer" src="../../../assets/index/chpc_home_count01.png"/>
                            <div class="data_count">
                                <span class="item-value">{{serverCount[5]}}+</span>
                                <span class="data_count_unit">次</span>
                            </div>
                            <span class="item-desc">年均商业<br />及终端执行量</span>
                            <div class="item-divider"></div>
                        </div>

                        <div class="service-item flex-col align-center">
                            <img class="label_icon" referrerpolicy="no-referrer" src="../../../assets/index/chpc_index.map_02.png"/>
                            <div class="data_count">
                                <span class="item-value">{{serverCount[6]}}+</span>
                                <span class="data_count_unit">个</span>
                            </div>
                            <span class="item-desc">近3年<br />走访经销商</span>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        props: {
        },
        data() {
            return {
                serverCount: [0, 0, 0, 0, 0, 0, 0, 0], // 初始值设为0
                targetValues: [20, 30, 100, 300, 900, 7000, 8000, 590], // 目标值
                hasAnimated: false, // 防止重复触发

            };
        },
        mounted() {
            // 使用 Intersection Observer 监听元素
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.hasAnimated) {
                        this.startCounterAnimation();
                        this.hasAnimated = true;
                    }
                });
            });

            // 获取目标元素（给block_server添加ref）
            const targetElement = this.$refs.serviceAdvantages;
            if (targetElement) {
                observer.observe(targetElement);
            }
        },
        methods: {
            startCounterAnimation() {
                const duration = 1500; // 3秒
                const startTime = Date.now();

                const animate = () => {
                    const elapsed = Date.now() - startTime;
                    const progress = Math.min(elapsed / duration, 1);

                    this.serverCount = this.targetValues.map(target => {
                        return Math.floor(progress * target);
                    });

                    if (progress < 1) {
                        requestAnimationFrame(animate);
                    } else {
                        this.serverCount = [...this.targetValues]; // 确保最终值准确
                    }
                };

                requestAnimationFrame(animate);
            },
        },
        watch: {
        }
    };
</script>

<style scoped lang="css"  >

    .page_home_server {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
    }


    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .group_179 {
        position: relative;
        width: 100%;
        max-width: 1200px;
        height: auto;
        min-height: 200px;
        margin-top: 20px;
        justify-content: center;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .block_server {
        position: relative;
        left: auto;
        transform: none;
        width: 90%;
        max-width: 1200px;
        height: auto;
        min-height: 200px;
        background: url(../../../assets/index/chpc_home_index_mobile.png) 100% no-repeat;
        background-position: center center;
        background-attachment: local;
        background-size: cover;
        padding: 20px;
        margin: 0 auto;
    }

    .text-group_365 {
        margin-top: 25px;
        width: 294px;
        height: 89px;
        align-items: center;
    }

    .text_63 {
        width: 152px;
        height: 53px;
        overflow-wrap: break-word;
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
    }

    .text_64 {
        width: 294px;
        height: 30px;
        overflow-wrap: break-word;
        font-size: 26px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        color: #878787;
        text-align: center;
        white-space: nowrap;
        line-height: 31px;
    }

    .box_content {
        width: 100%;
        max-width: 1200px;
        height: auto;
        min-height: 200px;
        background: rgba(0,113,150,0.8);
        margin: 20px 20px 20px 20px;

        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .section_83, .section_84 {
        width: 100%;
        height: auto;
        margin: 20px 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .service-item {
        position: relative;
        width: 23%;
        height: 100%;
        justify-content: center;
    }

    .service-item img {
        width: 40px;
        height: 40px;
        margin-bottom: 10px;
    }

    .item-value {
        height: 53px;
        color: rgba(255, 255, 255, 1);
        font-size: 38px;
        letter-spacing: 0.018296295776963234px;
        font-family: AlibabaPuHuiTi_3_105_Heavy;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
        margin-bottom: 5px;

        transition: all 0.3s ease-out;
        font-variant-numeric: tabular-nums;
    }

    .item-desc {
        width: 100%;
        height: 50px;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        letter-spacing: 0.00866px;
        text-align: center;
        line-height: 25px;
    }

    .item-divider {
        position: absolute;
        right: -15px;
        top: 50%;
        transform: translateY(-50%);
        background-color: rgba(255, 255, 255, 0.28);
        width: 1px;
        height: 98px;
    }

    .data_count {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        letter-spacing: -0.3em;
    }

    .data_count span {
        display: inline-block;
        text-align: center;
        letter-spacing: normal;
    }
    .data_count_pre {
        width: 17px;
        height: 24px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: 400;
        font-size: 17px;
        color: #FFFFFF;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        margin-right: 5px;
        opacity: 0.65;
    }

    .data_count_unit {
        margin-left: 10px;
        width: 17px;
        height: 24px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: 400;
        font-size: 17px;
        color: #FFFFFF;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        opacity: 0.65;
    }

    .label_icon {
        width: 40px;
        height: 40px;
        margin: 0 auto 10px;
        display: block;
    }


    .clamp-2 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.4;
        max-height: 3em;
    }

    .clamp-2 >>> * {
        display: inline !important;
        margin: 0 !important;
        padding: 0 !important;
    }



    @media (min-width: 375px) and (max-width: 750px){
        .block_server {
            width: 99%;
            padding: 10px;
        }
        .box_content {
            padding: 10px;
            margin: 10px 25px 10px 0;
    }
    .text_63 {
        font-size: 25px;
        font-weight: 500;
        height: 40px;
        line-height: 40px;
    }
    .text_64 {
        font-size: 14px;
        margin-top: 0px;
        line-height: 20px;
    }
    .section_83, .section_84 {
        margin: 15px 0;
        justify-content: center !important; /* 强制居中 */
            gap: 2px;
        }
        .item-divider {
            right: 0px;
            height: 45px;
        }
        .service-item img {
            width: 20px;
            height: 20px;
            margin-bottom: 5px;
        }
        .label_icon {
            width: 20px;
            height: 20px;
            margin: 0 auto 5px;
            display: block;
        }
        .item-desc {
            font-size: 9px;
            line-height: 14px;
            height: 35px;
        }
        .item-value {
            font-size: 16px;
            height: 25px;
            line-height: 30px;
        }

        .data_count_pre {
            font-size: 10px;
            margin-right: 2px;

        }
        .data_count_unit {
            font-size: 10px;
            margin-left: 2px;
        }
        .group_179 {
            margin-top: 0px;
        }


    }

    @media (max-width: 480px) {
        .block_server {
            width: 99%;
            padding: 10px;
        }
        .box_content {
            padding: 10px;
            margin: 10px 25px 10px 0;
        }
        .text_63 {
            font-size: 25px;
            font-weight: 500;
            height: 40px;
            line-height: 40px;
        }
        .text_64 {
            font-size: 14px;
            margin-top: 0px;
            line-height: 20px;
        }
        .section_83, .section_84 {
            margin: 15px 0;
            justify-content: center !important; /* 强制居中 */
            gap: 2px;
        }
        .item-divider {
            right: 0px;
            height: 45px;
        }
        .service-item img {
            width: 20px;
            height: 20px;
            margin-bottom: 5px;
        }
        .label_icon {
            width: 20px;
            height: 20px;
            margin: 0 auto 5px;
            display: block;
        }
        .item-desc {
            font-size: 9px;
            line-height: 14px;
            height: 35px;
        }
        .item-value {
            font-size: 16px;
            height: 25px;
            line-height: 30px;
        }

        .data_count_pre {
            font-size: 10px;
            margin-right: 2px;

        }
        .data_count_unit {
            font-size: 10px;
            margin-left: 2px;
        }
        .group_179 {
            margin-top: 0px;
        }

    }


</style>
